import { Entity } from "./entity";
import { Agency } from "./agency";
import { Principal } from "./principal";

export class PrincipalAuth extends Entity {
    PrincipalId: number;
    AgencyId: number;
    UserPath?: string;

    Agency: Agency;
    Principal: Principal | null;

    static newItem(): PrincipalAuth {

        let item = new PrincipalAuth();
        item.Id = 0;
        return item;
    }

}

export class PrincipalAuthSearchModel extends Entity {
    PrincipalId: number;
}